export enum MeasureUnitCode {
  PERCENT = 'PERCENT',
  QUANTITY = 'QTY',
  CURRENCY = 'CURRENCY',
  FLOAT = 'FLOAT',
  NONE = 'NONE',
  RATE = 'RATE',
  // TODO: Remove and use quantity (its a count)
  COUNT = 'COUNT',
}
